<template>
    <div class="main-sections text-center">
        <p></p>
        <h1 class="font-weight-bold">🌍 Football Transfer Quiz ⚽️</h1>
        <p></p>

        <h2 class="font-weight-bold">Play Now</h2>
        <ButtonRow />
        <p></p>
        <p>Guess the football player from the clubs they played for. Can you guess the player from their carreer?</p>
        <div id="tutorial" class="tutorial-container">
            <Tutorial />
        </div>

        <p></p>
        <p></p>

        <div id="hiscores">
            <Hiscores />
        </div>

    </div>
</template>


<script>
import Hiscores from './Hiscore.vue'
import ButtonRow from './components/ButtonRow.vue'
import PlayerHistory from './components/PlayerHistory.vue';
import PlayerCard from './components/PlayerCard.vue';
import Tutorial from './Tutorial.vue'
import axios from 'axios';
import _ from 'lodash';

export default {
    components: {
        PlayerHistory,
        PlayerCard,
        ButtonRow,
        Tutorial,
        Hiscores
    }
}
</script>

<style scoped>
.main-sections {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
}

.tutorial-container {
    max-width: 80em;
}
</style>
